import React, {useEffect} from "react";
import clsx from 'clsx';
import SelectProject from "../BreadcrumbComponents/SelectProject";
import SelectPage from "../BreadcrumbComponents/SelectPage";
import ViewDataFlow from "../BreadcrumbComponents/ViewDataFlow";
import DesignView from "../BreadcrumbComponents/DesignView";
import ViewDataModelProject from "../BreadcrumbComponents/ViewDataModelProject";
import ViewProjectQuality from "../BreadcrumbComponents/ViewProjectQuality";

const ViewPageDataModelBreadcrumb = (props) => {

    const{
        selectedPage,
        selectedProject,
        setSelectedPage,
        setSelectedProject,
        loadPages,
        setLoadPages
    }= props;

    const [pagesNames, setPagesNames] = React.useState([]);
    
    const changeProject = (option) => {
        
        let index = 0;

        JSON.parse(localStorage.getItem('data'))
        .forEach( (element, indexEl) => {
        if(element.name === option){
            index = indexEl;
        }
        }) 
        
        localStorage.setItem('selectedProject',index);
        localStorage.setItem('selectedPage',-1);
        setSelectedProject(index);
        setSelectedPage(-1);
    }

    const changePagePerProjectTable = (index) => {
        localStorage.setItem('selectedPage',index);
        setSelectedPage(index);
    }

    useEffect( () => {
        if(loadPages === true){
            const tempData = JSON.parse(localStorage.getItem('data'));
            const tempPagesNames = [];
            if(selectedProject > -1){
                
                tempData[selectedProject].pages.forEach( (page) => {
                    tempPagesNames.push(page.name);
                })
            }
            setPagesNames(tempPagesNames);
            setLoadPages(false);
        }
    },[selectedPage, selectedProject,loadPages])

    return(
        <div style={{ backgroundColor: '#CFD8E0' }}>

            <div className={clsx('generalMarg','flexRowDirection')} style={{justifyContent: 'space-between'}}>
                <div className={clsx('flexRowDirection') } style={{width: '75%', padding: '0vw'}}>
                    <SelectProject
                        changeProject={changeProject}
                        selectedProject={selectedProject}
                    />
                    <SelectPage
                        pagesNames={pagesNames}
                        selectedPage={selectedPage}
                        selectedProject={selectedProject}
                        changePagePerProjectTable={changePagePerProjectTable}
                    /> 
                </div>
                <div className={clsx('flexRowDirection')} >
                    <ViewDataModelProject/>
                    <ViewDataFlow/>
                    <ViewProjectQuality/>
                    <DesignView
                        selectedProject={selectedProject}
                    />
                </div>
            </div>
        </div>
    )
}

export default ViewPageDataModelBreadcrumb;